// extracted by mini-css-extract-plugin
module.exports = {"donutContainer":"StructureDonut_donutContainer__4OBwE","donutContainerExpanded":"StructureDonut_donutContainerExpanded__2pYga"};